import {getCkanPackageUrl, getCkanResourceUrl, getPackageUrl, getResourceUrl} from "../../constants/apiEndpoints";
import {NODE_TYPE_CKAN} from "../../constants/nodes";
import {initRequest, RequestMethod} from "../request/requestActions";
import {
  getCkanDatasetFromDataset,
  getCkanResourceFromResource,
  getDataPortalDatasetFromDataset,
  getDataPortalResourceFromResource
} from "../../components/package-manager/utils";

export const PACKAGE_MANAGER_MIDDLEWARE_PACKAGE_CREATE = "packageManager/middleware/package/create";
export const PACKAGE_MANAGER_MIDDLEWARE_RESOURCE_CREATE = "packageManager/middleware/resource/create";

export const createPackage = (nodeId, nodeType, dataset, resource, language) => {
  const isCkanNode = nodeType === NODE_TYPE_CKAN;

  const data = isCkanNode ? getCkanDatasetFromDataset(dataset) : getDataPortalDatasetFromDataset(dataset, language);

  const formData = new FormData();
  formData.append("json", JSON.stringify(data));

  return initRequest(
    PACKAGE_MANAGER_MIDDLEWARE_PACKAGE_CREATE,
    isCkanNode ? getCkanPackageUrl(nodeId) : getPackageUrl(nodeId),
    RequestMethod.POST,
    formData,
    t => ({
      onStart: t("modules.packageManager.actions.messages.createPackage")
    }),
    {
      nodeId: nodeId,
      resource: resource,
      nodeType: nodeType
    }
  );
};

export const createResource = (nodeId, nodeType, resource, packageId, language) => {
  const isCkanNode = nodeType === NODE_TYPE_CKAN;

  const data = isCkanNode
    ? getCkanResourceFromResource(resource)
    : getDataPortalResourceFromResource(resource, language);

  const formData = new FormData();
  formData.append("json", JSON.stringify(data));
  formData.append("files", resource.content);

  return initRequest(
    PACKAGE_MANAGER_MIDDLEWARE_RESOURCE_CREATE,
    isCkanNode ? getCkanResourceUrl(nodeId) : getResourceUrl(nodeId),
    RequestMethod.POST,
    formData,
    t => ({
      onStart: t("modules.packageManager.actions.messages.createResource")
    }),
    {
      packageId: packageId
    }
  );
};
